import {Component, ElementRef, Inject, NgZone, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MapsAPILoader} from '@agm/core';
import {IDialogMapReturn} from '../../../interface/dataset-params';

@Component({
    selector: 'noos-dialog-google-map',
    templateUrl: './dialog-google-map.component.html',
    styleUrls: ['./dialog-google-map.component.scss']
})
export class DialogGoogleMapComponent implements OnInit {

    latitude: number;
    longitude: number;
    zoom = 18;

    address: string;
    private geoCoder;

    @ViewChild('search', {static: true})
    public searchElementRef: ElementRef;


    constructor(public dialogRef: MatDialogRef<DialogGoogleMapComponent>,
                @Inject(MAT_DIALOG_DATA) public data: any,
                private mapsAPILoader: MapsAPILoader,
                private ngZone: NgZone) {
    }

    ngOnInit() {


        this.mapsAPILoader.load().then(() => {


            // tslint:disable-next-line:new-parens
            this.geoCoder = new google.maps.Geocoder;

            const autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {
                types: ['address']
            });
            autocomplete.addListener('place_changed', () => {
                this.ngZone.run(() => {
                    // get the place result
                    const place: google.maps.places.PlaceResult = autocomplete.getPlace();

                    // verify result
                    if (place.geometry === undefined || place.geometry === null) {
                        return;
                    }

                    // set latitude, longitude and zoom
                    this.latitude = place.geometry.location.lat();
                    this.longitude = place.geometry.location.lng();
                    this.zoom = 12;
                });
            });

            if (this.data.toString() !== '' && this.data) {
                const positionInput = this.data.toString().split(',');
                this.latitude = parseFloat(positionInput[0]);
                this.longitude = parseFloat(positionInput[1]);
                setTimeout(() => {
                    this.getAddress(this.latitude, this.longitude);
                }, 2000);
            }


        });

    }

    resetCurrentLocation() {
        this.searchElementRef.nativeElement.value = '';
        this.setCurrentLocation();
    }

    private setCurrentLocation() {

        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
                this.latitude = position.coords.latitude;
                this.longitude = position.coords.longitude;
                this.zoom = 18;
                this.getAddress(this.latitude, this.longitude);
            }, (error) => {
            }, {timeout: 500});
        }
    }

    markerDragEnd($event: MouseEvent) {

        // @ts-ignore
        console.log($event, '---', $event.coords);

        // @ts-ignore
        this.latitude = $event.coords.lat;
        // @ts-ignore
        this.longitude = $event.coords.lng;
        this.getAddress(this.latitude, this.longitude);
    }

    getAddress(latitude, longitude) {
        this.geoCoder.geocode({location: {lat: latitude, lng: longitude}}, (results, status) => {
            if (status === 'OK') {
                if (results[0]) {
                    this.zoom = 18;
                    this.address = results[0].formatted_address;
                } else {
                    window.alert('No results found');
                }
            } else {
                window.alert('Geocoder failed due to: ' + status);
            }

        });
    }

    onNoClick() {
        this.dialogRef.close();
    }

    onSave() {
        const response: IDialogMapReturn = {
            latitude: this.latitude,
            longitude: this.longitude,
            address: this.address
        };
        this.dialogRef.close(response);
    }

    markerDragEnd2($event: google.maps.MouseEvent) {
        console.log($event.latLng.lat(), $event.latLng.lng());

        this.getAddress($event.latLng.lat(), $event.latLng.lng());

    }
}
